export const checkIsTableWaiterNotified = (table) => {
	return ['orders', 'splits', 'payBeforeOrders'].reduce((acc, key) => {
		return acc || table?.[key]?.some(order =>
			order.items?.some(item => item?.kitchenMeta?.notificationStatus === 'WAITER_NOTIFIED'),
		)
	}, false)
}
